'use client';

import { ReactNode, memo } from 'react';

import { Button } from '../Button';
import { Modal } from '../Modal';
import ErrorIcon from '../assets/svgs/error.svg';
import styles from './errorModal.module.scss';

export interface ErrorModalProps {
  isOpen: boolean;
  className?: string;
  errorMessage?: ReactNode;
  errorDescription?: ReactNode;
  onClose: () => void;
  onExit: () => void;
}

export const ErrorModal = memo((props: ErrorModalProps) => {
  const {
    errorMessage = (
      <>
        There was an unexpected error.
        <br />
        Please try again later.
      </>
    ),
    errorDescription,
    isOpen,
    onExit,
    ...modalProps
  } = props;
  return (
    <Modal isShow={isOpen} {...modalProps} size='small' header={null} onExit={onExit}>
      <div className={styles.contents}>
        <ErrorIcon className={styles.icon} />
        <h2 className={styles.title}>Error</h2>
        <p className={styles.errorMessage}>{errorMessage}</p>
        {errorDescription && <p className={styles.errorDescription}>{errorDescription}</p>}
        <div className={styles.buttonArea}>
          <Button className={styles.button} onClick={props.onClose}>
            Dismiss
          </Button>
        </div>
      </div>
    </Modal>
  );
});
